var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 9.375C7.86336 9.375 7.81006 9.35465 7.76937 9.31396L5 6.54459L2.23063 9.31396C2.14925 9.39534 2.01741 9.39534 1.93603 9.31396L0.686034 8.06396C0.604655 7.98258 0.604655 7.85075 0.686034 7.76937L3.4554 5L0.686034 2.23063C0.604655 2.14925 0.604655 2.01741 0.686034 1.93603L1.93603 0.686034C2.01741 0.604655 2.14925 0.604655 2.23063 0.686034L5 3.4554L7.76937 0.686034C7.85075 0.604655 7.98258 0.604655 8.06396 0.686034L9.31396 1.93603C9.39534 2.01741 9.39534 2.14925 9.31396 2.23063L6.54459 5L9.31396 7.76937C9.39534 7.85075 9.39534 7.98258 9.31396 8.06396L8.06396 9.31396C8.02327 9.35465 7.96997 9.375 7.91667 9.375Z",
    fill: "#E86C60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default ForwardRef;